<template>
  <div>
    <div class="p-0">
      <div class="my-2 font-bold">신청현황</div>
      <b-card-group deck>
        <b-card>
          <h4 class="text-2xl font-semibold text-gray-700">{{todayCount}}</h4>
          <div class="text-gray-500">당일 신청</div>
        </b-card>
        <b-card>
          <h4 class="text-2xl font-semibold text-gray-700">{{totalCount}}</h4>
          <div class="text-gray-500">총 신청</div>
        </b-card>
      </b-card-group>
    </div>
    <div class="p-0">
      <div class="my-2 font-bold">당일 신청현황 (신청 URL별)</div>
      <b-card-group v-if="totalCountsByPageURL.length === 0">
        <b-card>
          <span class="text-gray-500">없음</span>
        </b-card>
      </b-card-group>
      <b-card-group deck v-if="totalCountsByPageURL.length > 0">
        <b-card v-for="(totalCountByPageURL, index) in totalCountsByPageURL" :key="index">
          <h4 class="text-2xl font-semibold text-gray-700">{{totalCountByPageURL.requestCount}}</h4>
          <div class="text-gray-500">{{totalCountByPageURL.pageUrl}}</div>
        </b-card>
      </b-card-group>
    </div>
    <div class="my-3 min-width-full">
      <div class="rounded-lg shadow bg-white p-4">
        <div class="inline-flex justify-end gap-2 items-center w-full">
          <Button :type="ButtonTypes.blue" label="기초반 대량 업데이트" :onClick="clickFileUpload" :loading="loading.uploadExcel"/>
          <input
            type="file"
            ref="fileInput"
            class="hidden"
            accept=".xls,.xlsx"
            @change="upload"
          />
          <Button :type="ButtonTypes.green" label="엑셀 다운로드" :onClick="download" :loading="loading.exportExcel"/>
          <Button :type="ButtonTypes.green" label="신청 URL별 신청수 다운로드" :onClick="downloadStaticsExcel" :loading="loading.registerContExcel"  v-if="isSuperAdmin || role === 'ROLE_READ_ADMIN'"/>
          <Button :type="ButtonTypes.red" label="일괄삭제" :onClick="deleteAll" v-if="isSuperAdmin"/>
        </div>
        <div class="inline-flex gap-2 justify-start items-center my-3 flex-wrap">
          <VueDatePicker
            v-model="selectedDate"
            range
            :teleport="true"
            format="yyyy-MM-dd HH:mm:ss"
            :clearable="true"
            multi-calendars
            placeholder="검색시작일, 종료일을 선택하세요."
            class="!w-[400px]"
          />
          <b-input-group class="!w-[300px]">
            <b-form-input
              id="inline-form-input-name"
              class=" mr-sm-2 md-4"
              placeholder="이름 또는 전화번호를 입력하세요."
              v-model="keyword"
              v-on:keyup.enter="handleSearch"
            ></b-form-input>
            <b-input-group-append>
              <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <b-table :fields="fields" :items="requestConsulting" class="text-left responsive">
          <template #cell(createdAt)="data">
            {{ getDate(data.item.createdAt)}}
          </template>
          <template #cell(confirmed)="data">
            <span>{{ data.item.confirmed ? 'O' : 'X' }}</span>
          </template>
          <template #cell(button2)="data" v-if="isSuperAdmin">
            <button class="btn btn-primary mr-3" v-show="data.item.sendMessageStatus === 'FAILED'" v-on:click="sendMessage(data.item)">재전송</button>
          </template>
          <template #cell(button1)="data" v-if="isSuperAdmin">
            <button class="btn btn-outline-danger" v-on:click="setDelete(data.item)">삭제</button>
          </template>
        </b-table>
        <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="pageSize"
          @page-click="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api"
import customDate from "@/util/custom-date"
import moment from "moment";
import Button from "@/components/Button.vue";
import {ButtonTypes} from "@/util/enums";
import Excel from "@/util/excel";
import {mapActions} from "vuex";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    },
    canUpdateConfirmed() {
      return this.isSuperAdmin
    }
  },
  components: {Button},
  data(){
    return {
      totalCount : 0,
      todayCount: 0,
      totalCountsByPageURL: [],
      requestConsulting: [],
      isInitialized: false,
      currentPage: 1,
      pageSize:30,
      totalPage: 1,
      totalRows: 1,
      searchStartDate: null,
      searchEndDate: null,
      keyword: "",
      selectedDate: [moment().set({'date': 1, hour: 0, minute: 0, second: 0}).toDate(), moment().toDate()],
      role: localStorage.getItem('ROLE'),
      loading: {
        exportExcel: false,
        registerContExcel: false,
        uploadExcel: false,
      },
      isSuperAdmin: localStorage.getItem("IS_SUPER_ADMIN") === "true",
      fields: localStorage.getItem("IS_SUPER_ADMIN") === "true" ? [
        {
          label: '이름',
          key: 'name',
        },
        {
          label: '나이',
          key: 'age',
        },
        {
          label: '학생코드',
          key: 'accessCode',
        },
        {
          label: '전화번호',
          key: 'phoneNumber',
        },
        {
          label: '상담신청일',
          key: 'createdAt',
        },
        {
          label: '확정 여부',
          key: 'confirmed',
        },
        {
          label: '신청 URL',
          key: 'pageUrl',
        },
        {
          label: '추천코드',
          key: 'referralCode',
        },
        {
          label: '',
          key: 'button2',
        },
        {
          label: '',
          key: 'button1',
        },
      ] : (
        localStorage.getItem('ROLE') === 'ROLE_CALL_ADMIN' ?
          [
            {
              label: '전화번호',
              key: 'phoneNumber',
            },
            {
              label: '상담신청일',
              key: 'createdAt',
            },
            {
              label: '확정 여부',
              key: 'confirmed',
            },
            {
              label: '추천코드',
              key: 'referralCode',
            },
          ] :
          [
            {
              label: '나이',
              key: 'age',
            },
            {
              label: '상담신청일',
              key: 'createdAt',
            },
            {
              label: '신청 URL',
              key: 'pageUrl',
            },
            {
              label: '추천코드',
              key: 'referralCode',
            },
          ]
      ),
    }
  },
  watch: {
    selectedDate() {
      if (this.isInitialized) {
        this.currentPage = 1
        this.updateQueryParams()
        this.getPagingList(1)
      }
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.keyword = query.keyword
    }
    if (query.startDate && query.endDate) {
      this.selectedDate = [new Date(query.startDate), new Date(query.endDate)]
    }
    
    this.statics()
    this.getPagingList(this.currentPage)
    
    // 초기화 완료 후 watch 활성화
    this.$nextTick(() => {
      this.isInitialized = true
    })
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.keyword) {
        query.keyword = this.keyword
      }
      if (this.selectedDate && this.selectedDate.length === 2) {
        query.startDate = this.selectedDate[0].toISOString()
        query.endDate = this.selectedDate[1].toISOString()
      }
      
      this.$router.replace({ query })
    },
    getDate(date) {
      return customDate.stringFormat(date)
    },
    changeDate() {
      if (this.searchStartDate && this.searchEndDate) {
        this.getPagingList(1)
      }
    },
    statics() {
      api.requestConsulting.getCount(null,(response) => {
        const {totalCount, todayCount, totalCountsByPageURL} = response.data
        this.totalCount = totalCount
        this.todayCount = todayCount
        this.totalCountsByPageURL = totalCountsByPageURL
      })
    },
    download() {
      const params = {
        keyword : this.keyword,
        startedAt: null,
        endedAt: null
      }

      if (this.selectedDate?.length > 1) {
        if (this.selectedDate?.[0]) {
          params.startedAt = moment(this.selectedDate?.[0]).format('YYYY-MM-DDTHH:mm:ss')
        }
        if (this.selectedDate?.[1]) {
          params.endedAt = moment(this.selectedDate?.[1]).format('YYYY-MM-DDTHH:mm:ss')
        }
      }
      this.loading.exportExcel = true
      api.requestConsulting.downloadExcel(params, (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `상담신청현황_${new Date().toISOString()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.loading.exportExcel = false
      }) 
    },
    downloadStaticsExcel() {
      this.loading.registerContExcel = true
      api.requestConsulting.downloadStaticsExcel((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `상담신청현황_url별_신청수_${new Date().toISOString()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.loading.registerContExcel = false
      })
    },
    setConfirmed(consulting) {
      api.requestConsulting.setConfirmed({id: consulting.id}, () => {
        consulting.confirmed = !consulting.confirmed
        this.requestConsulting = this.requestConsulting.map((item) => (
          item.id === consulting.id ? {...item, confirmed: consulting.confirmed} : item
        ))
      }, (err) => {
        console.log(err)
      })
    },
    setDelete(consulting){
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '상담 신청 내역 삭제',
        html: `${consulting.name}님의 상담 신청내역을 삭제합니다.\n삭제 처리가 되면 다시 복원이 불가능합니다.\n삭제 하시겠습니까?`,
        confirm: () => {
          api.requestConsulting.setDelete({id: consulting.id} , () => {
            this.getPagingList(this.currentPage)
            this.statics()
          },(err) => {
            console.log(err)
          })
        }
      });
    },
    deleteAll(){
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '상담 신청 내역 삭제',
        html: "상담 신청내역 전부 삭제합니다.\n삭제 처리가 되면 다시 복원이 불가능합니다.\n삭제 하시겠습니까? \n(알림톡 발송 실패건을 제외하고 삭제처리됩니다.)",
        confirm: () => {
          api.requestConsulting.deleteAll(null , () => {
            this.getPagingList(this.currentPage)
            this.statics()
          },(err) => {
            console.log(err)
          })
        }
      });
    },
    getPagingList(page) {
      const params = {
        page: page,
        keyword : this.keyword,
        startedAt: null,
        endedAt: null
      }
      
      if (this.selectedDate?.length > 1) {
        if (this.selectedDate?.[0]) {
          params.startedAt = moment(this.selectedDate?.[0]).format('YYYY-MM-DDTHH:mm:ss')
        }
        if (this.selectedDate?.[1]) {
          params.endedAt = moment(this.selectedDate?.[1]).format('YYYY-MM-DDTHH:mm:ss')
        }
      }
      this.currentPage = page
      
      api.requestConsulting.list(params,(response) => {
        const {content, totalElements, totalPages} = response.data
        this.requestConsulting = content
        this.totalRows = totalElements
        this.totalPage = totalPages
      }, (err) => {
        console.log(err)
      })
    },
    sendMessage(consulting){
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '알림톡 재전송',
        html:`${consulting.name}님에게 알림톡을 다시 보낼까요?`,
        confirm: () => {
          api.requestConsulting.sendMessage({id: consulting.id} , () => {
            this.getPagingList(this.currentPage)
            this.statics()
          },(err) => {
            console.log(err)
          })
        }
      });
    },
    clickFileUpload() {
      this.openModal({
        type: 'confirm',
        isOpen: true,
        title: '기초반 대량 업데이트',
        html: '<p class="break-words">엑셀로 기초반을 추가합니다.<br/> 진행하시겠습니까?</p>',
        confirm: () => {
          this.$refs.fileInput.click()
        },
      });
    },
    upload(event) {
      const uploadFile = event.target.files[0];

      // 파일이 선택되지 않은 경우
      if (!uploadFile) {
        return;
      }

      // 파일명으로 확장자 검증 (서버와 동일한 방식)
      const fileName = uploadFile.name.toLowerCase();
      if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
        this.$toast.show('엑셀 형식만 올릴 수 있습니다.',
          {
            position: "top-right",
            duration: 2000
          });
        event.target.value = null;
        return
      }

      this.file = uploadFile;

      this.loading.uploadExcel = true
      api.requestConsulting.createRequestConsultingByExcel({file: this.file}, (response) => {
        Excel.download(response.data, '기초반_대량_업데이트')
        this.$refs.fileInput.value = null;
        this.loading.uploadExcel = false
        this.selectedDate = [moment().set({'date': 1, hour: 0, minute: 0, second: 0}).toDate(), moment().toDate()]
        this.getPagingList(1)
        this.statics()
      }, (e) => {
        console.error(e)
        this.loading.uploadExcel = false
      })
    },
  }
}
</script>
<style scoped>
  .text-right{
    text-align: right;
  }
</style>
